export default function Hero() {
  return (
    <section className="relative w-full min-h-screen flex flex-col">
      <div className="flex-1 flex flex-col items-center justify-center px-4 md:px-6 pt-20 pb-10 md:pb-16">
        <p className="text-xs md:text-sm tracking-widest uppercase text-foreground-500 font-medium mb-6 md:mb-8 animate-fade-up">
          Software Engineering
        </p>
        <h1 className="font-heading text-3xl md:text-5xl lg:text-6xl font-bold text-foreground-950 text-center leading-tight tracking-tight animate-fade-up animation-delay-200">
          PROJEKTU REMAI, MB
        </h1>
        <p className="font-heading text-lg md:text-2xl lg:text-3xl text-foreground-700 font-light mt-4 md:mt-6 text-center animate-fade-up animation-delay-400">
          Engineering Modern iOS Solutions
        </p>
        <p className="text-sm md:text-base text-foreground-500 mt-6 md:mt-8 text-center max-w-2xl leading-relaxed animate-fade-up animation-delay-600">
          A professional engineering team focused on designing and developing modern digital software
          solutions for the iOS platform and related technologies. We build scalable, maintainable,
          and high-performance systems with a strong focus on usability, stability, and long-term
          technical quality.
        </p>
      </div>

      <div className="w-full px-4 md:px-8 pb-8 md:pb-14">
        <div className="w-full h-[280px] md:h-[420px] lg:h-[520px] rounded-2xl overflow-hidden">
          <img
            src="https://readdy.ai/api/search-image?query=Abstract%20technological%20visualization%20with%20flowing%20geometric%20lines%20and%20soft%20gradient%20layers%2C%20deep%20green%20and%20warm%20amber%20tones%20blending%20seamlessly%2C%20clean%20architectural%20wireframe%20structures%20floating%20in%20a%20minimalist%20composition%2C%20ethereal%20digital%20landscape%20suggesting%20software%20architecture%20and%20system%20design%2C%20subtle%20light%20particles%20dispersed%20across%20a%20dark%20elegant%20background%2C%20editorial%20photography%20style%20with%20high%20detail%20and%20harmonious%20depth&width=1600&height=700&seq=hero-abstract-tech&orientation=landscape"
            alt="Abstract technological visualization representing software architecture and system design"
            title="PROJEKTU REMAI, MB — Modern iOS Platform Engineering"
            className="w-full h-full object-cover object-top"
          />
        </div>
      </div>
    </section>
  );
}